export default __webpack_public_path__ + "static/media/madame_detail17.2c119b0b.jpg";